module.exports = __webpack_public_path__ + "media/src/images/phone-b8a7dc6fbdaf28f4a73477eda16b3bd6.png";